export const ADMIN_PROFILE_SETTINGS_CONFIRMATION_EMAIL_ROUTE_NAME = Symbol('admin.profile-settings.confirmation-email');
export const AFFILIATE_PROFILE_SETTINGS_CONFIRMATION_EMAIL_ROUTE_NAME = Symbol('affiliate.profile-settings.confirmation-email');

export const PROFILE_SETTINGS_CONFIRMATION_EMAIL_SAVE_URL = 'confirmation';
export const PROFILE_SETTINGS_CONFIRMATION_EMAIL_SAVE_MUTATION_KEY = 'profile-settings.confirmation-email.save';
